import React from 'react';
import { Row } from '@tanstack/react-table';
import { Load } from '../../../../types';
import { FC } from 'react';
import { DraftLoadProvider } from '../../hooks/draft-load-context';
import { LoadTableRow } from './load-table-row';
import { LoadTableStops } from '../stops/load-table-stops';
import { EditableLoadTableRow } from './editable-load-table-row';
import { useDraftsLoadsContext } from '../../drafts-loads-context';

interface ConditionalLoadTableRowProps {
    isRowExpanded: boolean;
    isRowEditable: boolean;
    row: Row<Load>;
}

// the idea behind this is only loading up DraftLoadProvider when necessary
// which is when the load is editable, mainly for performance reasons
export const ConditionalLoadTableRow: FC<ConditionalLoadTableRowProps> = (props) => {
    const { isRowExpanded, isRowEditable, row } = props;

    if (isRowEditable) {
        return (
            <EditableLoadTableRowWithProvider
                isRowExpanded={isRowExpanded}
                row={row}
            />
        );
    }

    return (
        <>
            <LoadTableRow row={row} />
            {isRowExpanded && (
                <LoadTableStops
                    load={row.original}
                />
            )}
        </>
    );
}

interface EditableLoadTableRowWithProviderProps {
    isRowExpanded: boolean;
    row: Row<Load>;
}

const EditableLoadTableRowWithProvider: FC<EditableLoadTableRowWithProviderProps> = (props) => {
    const { isRowExpanded, row } = props;
    const { handleGlobalIsDirtyChange } = useDraftsLoadsContext();

    return (
        <DraftLoadProvider
            inputLoad={row.original}
            handleGlobalIsDirtyChange={handleGlobalIsDirtyChange}
        >
            <EditableLoadTableRow
                isRowExpanded={isRowExpanded}
                row={row}
            />
        </DraftLoadProvider>
    );
}
